var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Dashboard_Icon",
    "data-name": "Dashboard Icon",
    transform: "translate(-579.615 -569.131)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_95490",
    "data-name": "Path 95490",
    d: "M718.395,578c0-2.142-.005-4.285,0-6.428a2.2,2.2,0,0,1,2.405-2.422q4.511-.006,9.022,0a2.216,2.216,0,0,1,2.408,2.43q0,6.369,0,12.737a2.207,2.207,0,0,1-2.443,2.444q-4.482.008-8.963,0a2.191,2.191,0,0,1-2.43-2.452C718.391,582.2,718.395,580.1,718.395,578Zm1.891-.056c0,2.083.013,4.166-.009,6.249-.005.5.127.693.66.689q4.362-.033,8.725,0c.5,0,.693-.126.69-.661q-.028-6.249,0-12.5c0-.5-.131-.7-.664-.691q-4.362.032-8.725,0c-.576-.006-.69.215-.685.727C720.3,573.813,720.286,575.876,720.286,577.939Z",
    transform: "translate(-122.621 -0.01)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95491",
    "data-name": "Path 95491",
    d: "M593.472,684.7c0,2.123,0,4.246,0,6.369a2.206,2.206,0,0,1-2.457,2.431q-4.482,0-8.963,0a2.219,2.219,0,0,1-2.415-2.423q0-6.4,0-12.8a2.19,2.19,0,0,1,2.377-2.391q4.54-.012,9.081,0a2.171,2.171,0,0,1,2.377,2.384C593.478,680.419,593.472,682.562,593.472,684.7Zm-1.891-.025c0-2.063-.014-4.127.01-6.19.006-.523-.127-.725-.69-.72-2.889.026-5.778.022-8.666,0-.519,0-.725.121-.721.69q.034,6.219,0,12.439c0,.591.206.726.755.722q4.274-.033,8.548,0c.584.005.789-.146.779-.756C591.559,688.807,591.581,686.743,591.581,684.68Z",
    transform: "translate(-0.016 -94.376)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95492",
    "data-name": "Path 95492",
    d: "M586.518,579.2c-1.513,0-3.026.008-4.54,0a2.189,2.189,0,0,1-2.358-2.35q-.01-2.682,0-5.365a2.2,2.2,0,0,1,2.316-2.341q4.6-.011,9.2,0a2.176,2.176,0,0,1,2.319,2.328q.018,2.712,0,5.424a2.159,2.159,0,0,1-2.336,2.3C589.584,579.2,588.051,579.2,586.518,579.2Zm.065-8.171c-1.454,0-2.908.019-4.361-.01-.526-.011-.736.127-.725.691.032,1.649.025,3.3,0,4.95-.006.478.133.66.633.657q4.42-.026,8.84,0c.477,0,.6-.182.6-.628-.018-1.67-.025-3.34,0-5.009.009-.532-.189-.67-.69-.661C589.451,571.042,588.017,571.024,586.583,571.024Z",
    fill: "#ffb600"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95493",
    "data-name": "Path 95493",
    d: "M725.277,739.894c1.513,0,3.026-.007,4.54,0a2.194,2.194,0,0,1,2.377,2.391q.008,2.653,0,5.306a2.206,2.206,0,0,1-2.357,2.361q-4.569.009-9.138,0a2.178,2.178,0,0,1-2.337-2.311q-.02-2.741,0-5.483a2.143,2.143,0,0,1,2.258-2.262C722.172,739.882,723.725,739.895,725.277,739.894Zm-.018,1.891c-1.454,0-2.908.014-4.361-.008-.47-.007-.667.122-.659.628q.037,2.5,0,5.009c-.009.533.192.663.691.66,2.888-.019,5.775-.024,8.663,0,.59.006.733-.2.723-.754q-.045-2.415,0-4.832c.01-.535-.141-.729-.7-.717C728.167,741.807,726.713,741.785,725.259,741.785Z",
    transform: "translate(-122.583 -150.828)",
    fill: "#ffb600"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardIcon);
export default __webpack_public_path__ + "static/media/Dashboard-Icon.f1531d7a38eaff6cec41f8abcfbcabcc.svg";
export { ForwardRef as ReactComponent };